import { LegalDocumentPage } from './components/LegalDocumentPage';
import { TERMS_AND_CONDITIONS } from './legal-content';

/** Terms & Conditions route (PP-029 / proweb-102 AC-003). */
export function TermsPage(): React.JSX.Element {
  return <LegalDocumentPage document={TERMS_AND_CONDITIONS} />;
}
